import t from "react";
import { tablet as p, mintelGray200 as n, mintelBlack as f } from "mintel-tokens";
import { useMediaQuery as C } from "react-responsive";
import s from "classnames";
import { I as V } from "./Icon-BuIPTPJn.es.js";
import { T as _ } from "./index-Dd-4N6BE.es.js";
import { u as F } from "./ThemeProvider--i7ESlT5.es.js";
import { u as M } from "./DarkModeProvider-xoZXm3ct.es.js";
import { C as N, a as y } from "./index-ngszEFaO.es.js";
import './CheckboxV2.css';const E = "CheckboxV2-module__container___vPmPc", I = "CheckboxV2-module__dark___HItgp", T = "CheckboxV2-module__compere___XtwNR", g = "CheckboxV2-module__indicator___5HATV", B = "CheckboxV2-module__label___EtTzy", o = {
  container: E,
  dark: I,
  default: "CheckboxV2-module__default___BtMtS",
  compere: T,
  indicator: g,
  label: B
}, z = (e) => e === "indeterminate" ? "checkbox_mixed" : e ? "checkbox_checked" : "checkbox_unchecked", W = ({
  value: e,
  onChange: l,
  id: r,
  label: a,
  disabled: c = !1,
  color: i = f,
  className: d = "",
  labelClassName: k = "",
  ...h
}) => {
  const u = C({ maxWidth: p }) ? _.Body2 : _.Body, b = F(), m = M(), x = m ? "#FFFFFF33" : i;
  return /* @__PURE__ */ t.createElement(
    N,
    {
      checked: e,
      onCheckedChange: l,
      id: r,
      disabled: c,
      ...h,
      className: s(
        o.container,
        o[b],
        { [o.dark]: m },
        d
      )
    },
    /* @__PURE__ */ t.createElement(y, { forceMount: !0, className: o.indicator }, /* @__PURE__ */ t.createElement(
      V,
      {
        name: z(e),
        size: "1.25rem",
        color: c ? n : x
      }
    )),
    !!a && /* @__PURE__ */ t.createElement(
      u,
      {
        responsive: !0,
        tagName: "label",
        htmlFor: r,
        color: c && n,
        className: s(o.label, k)
      },
      a
    )
  );
};
export {
  W as C
};
